export default __webpack_public_path__ + "static/media/users.1d368801.svg";